export default __webpack_public_path__ + "static/media/AddIcon.ed6fea47.svg";